module.exports = __webpack_public_path__ + "static/img/bx4.22a40b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bx4.png
// module id = ual+
// module chunks = 0